import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function useKalamaiBody() {
  useEffect(() => {
    document.body.classList.add("kalamai-body");
    return () => document.body.classList.remove("kalamai-body");
  }, []);
}

const Stars = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 80 }).map(() => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        d: 2 + Math.random() * 4,
        del: Math.random() * 4,
        op: Math.random() * 0.5 + 0.1,
      })),
    []
  );
  return (
    <div className="hero-stars" data-testid="hero-stars">
      {stars.map((s, i) => (
        <div
          key={i}
          className="star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            "--d": `${s.d}s`,
            "--del": `${s.del}s`,
            opacity: s.op,
          }}
        />
      ))}
    </div>
  );
};

const NotebookLines = () => (
  <div className="nb-lines">
    {Array.from({ length: 20 }).map((_, i) => (
      <div key={i} className="nb-line" style={{ top: `${28 + i * 28}px` }} />
    ))}
  </div>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);
const InstaIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
);
const XIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.261 5.632 5.903-5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);

const Landing = () => {
  useKalamaiBody();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [imgError, setImgError] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!name.trim() || !email.trim() || !phone.trim()) {
      toast.error("Please fill all fields.");
      return;
    }
    setLoading(true);
    try {
      const src = new URLSearchParams(window.location.search).get("src") || "website";
      const res = await axios.post(`${API}/waitlist?src=${encodeURIComponent(src)}`, {
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
      });
      if (res.data?.success) {
        toast.success(res.data.message || "You're on the list!");
        setSubmitted(true);
      } else {
        toast.error(res.data?.error || "Something went wrong. Try again.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.error || "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kalamai" data-testid="landing-page">
      {/* NAV */}
      <nav className="klm-nav">
        <div className="nav-inner">
          <div className="nav-logo">
            <span>KalamAI</span>
            <span>by Gyaantra Technologies</span>
          </div>
          <div className="nav-links">
            <a href="#how-it-works">How It Works</a>
            <a href="#features">Features</a>
            <a href="#institutes">For Institutes</a>
            <a href="#founders">Founders</a>
            <a href="#waitlist" className="nav-cta" data-testid="nav-join-waitlist">Join Waitlist</a>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <Stars />
        <div className="hero-tag"><span /> Now accepting early access — 15,000+ students on waitlist</div>
        <h1 className="hero-title">
          <span className="line1">Stop <span className="accent">Memorising.</span></span>
          Start <span className="accent2">Thinking.</span>
        </h1>
        <p className="hero-sub">KalamAI is your AI tutor that guides you to the answer — not just gives it. Built for JEE, NEET, Boards, Foundation &amp; Olympiad aspirants across India.</p>
        <div className="hero-btns">
          <a href="#waitlist" className="btn-primary" data-testid="hero-join-waitlist-btn">Join the Waitlist</a>
          <a href="#how-it-works" className="btn-secondary" data-testid="hero-how-it-works-btn">See How It Works</a>
        </div>

        <div className="tablet-wrapper">
          <div className="tablet-frame">
            <div className="tablet-screen">
              <div className="tablet-header">
                <div className="tablet-dot" style={{ background: "#ff5f57" }} />
                <div className="tablet-dot" style={{ background: "#febc2e" }} />
                <div className="tablet-dot" style={{ background: "#28c840" }} />
                <span className="tablet-title">KalamAI — Practice Session</span>
              </div>
              <div className="notebook">
                <NotebookLines />
                <div style={{ position: "relative", zIndex: 2 }}>
                  <div className="kalam-badge">🔬 Mathematics · Chapter 4 · Quadratic Equations</div>
                  <p className="problem-label">Q. Solve by factorisation:</p>
                  <p className="problem-text">x² − 5x + 6 = 0</p>
                  <div className="solution-steps">
                    <div className="step correct" style={{ fontSize: 17, color: "#2d5a27" }}>
                      <span className="step-checkmark">✓</span> We need two numbers that multiply to <strong>6</strong> and add to <strong>−5</strong>
                    </div>
                    <div className="step wrong" style={{ paddingBottom: 80 }}>
                      <span style={{ fontSize: 17, color: "#333" }}>∴ factors are <span className="wrong-highlight">(x + 2)(x + 3)</span> = 0</span>
                      <div className="hint-bubble">
                        <span className="hint-icon">K</span>
                        <span className="hint-text">Check the signs! If the product is <strong>+6</strong> and the sum is <strong>−5</strong>, what must the signs of both numbers be?</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <div className="proof-bar">
        <div className="proof-inner">
          <div className="proof-item"><div className="proof-num">15,000+</div><div className="proof-label">Students on LOI</div></div>
          <div className="proof-divider" />
          <div className="proof-item"><div className="proof-num">25 yrs</div><div className="proof-label">Faculty experience</div></div>
          <div className="proof-divider" />
          <div className="proof-item"><div className="proof-num">5 States</div><div className="proof-label">Outreach across India</div></div>
          <div className="proof-divider" />
          <div className="proof-item"><div className="proof-num">JEE + NEET</div><div className="proof-label">Full coverage</div></div>
        </div>
      </div>

      {/* PROBLEM */}
      <section id="what">
        <div className="section-inner">
          <div className="section-tag">The Problem</div>
          <h2 className="section-title">India has 2 crore JEE/NEET<br />aspirants. Most are failing them.</h2>
          <p className="section-sub">Not because they aren't smart — but because the system trains them to memorise, not think. KalamAI changes that — for Boards, JEE, NEET, Foundation, and Olympiads.</p>
          <div className="problem-grid">
            <div className="p-card">
              <div className="p-icon" style={{ background: "rgba(255,80,80,0.1)" }}>📚</div>
              <div className="arrow-down">↓ Old Way</div>
              <h3 style={{ color: "#ff6b6b" }}>Rote Learning</h3>
              <p>Students memorise solutions without understanding the concept. One variation breaks them completely.</p>
            </div>
            <div className="p-card" style={{ borderColor: "rgba(245,166,35,0.2)" }}>
              <div className="p-icon" style={{ background: "rgba(245,166,35,0.1)" }}>🤖</div>
              <div className="arrow-down">↓ AI Answer Apps</div>
              <h3 style={{ color: "var(--amber)" }}>Just Giving Answers</h3>
              <p>Most AI tools dump the answer instantly — robbing students of the struggle that builds real understanding.</p>
            </div>
            <div className="p-card" style={{ borderColor: "rgba(79,195,247,0.2)" }}>
              <div className="p-icon" style={{ background: "rgba(79,195,247,0.1)" }}>💡</div>
              <div className="arrow-down">↑ KalamAI Way</div>
              <h3 style={{ color: "var(--blue)" }}>Socratic Guidance</h3>
              <p>KalamAI asks you the right questions, highlights your error, and makes you arrive at the answer yourself.</p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="hiw-section" id="how-it-works">
        <div className="section-inner">
          <div className="section-tag" style={{ textAlign: "center" }}>How It Works</div>
          <h2 className="section-title" style={{ textAlign: "center" }}>Three steps to<br /><span style={{ background: "linear-gradient(90deg,var(--amber),var(--amber2))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>real understanding</span></h2>
          <div className="steps-grid">
            <div className="hiw-step"><div className="step-num">1</div><h3>Open KalamAI</h3><p>Open the KalamAI app or website on your tablet or device and pick your subject — Maths, Physics or Chemistry.</p></div>
            <div className="hiw-step"><div className="step-num">2</div><h3>Solve on the Notebook</h3><p>Write your solution directly on KalamAI's interactive notebook interface — just like your real notebook, but smarter.</p></div>
            <div className="hiw-step"><div className="step-num">3</div><h3>You Arrive. You Own It.</h3><p>KalamAI spots your error, asks the right question, and guides you to the answer yourself — building real exam-day confidence.</p></div>
          </div>
        </div>
      </section>

      {/* SOCRATIC DIFFERENCE */}
      <section>
        <div className="section-inner">
          <div className="section-tag" style={{ textAlign: "center" }}>The Difference</div>
          <h2 className="section-title" style={{ textAlign: "center" }}>Not just another<br />answer machine.</h2>
          <div className="diff-cards" style={{ marginTop: 56 }}>
            <div className="diff-card bad">
              <h4>Other AI Apps <span className="badge badge-bad">Old Way</span></h4>
              <div className="diff-item"><span className="diff-dot dot-bad" />"x² − 5x + 6 = (x−2)(x−3), so x = 2 or x = 3."</div>
              <div className="diff-item"><span className="diff-dot dot-bad" />Dumps the full solution in one shot</div>
              <div className="diff-item"><span className="diff-dot dot-bad" />Student copies, moves on, learns nothing</div>
              <div className="diff-item"><span className="diff-dot dot-bad" />Next variation → stuck again</div>
            </div>
            <div className="diff-card" style={{ borderColor: "rgba(79,195,247,0.25)" }}>
              <h4>KalamAI <span className="badge badge-good">Socratic Method</span></h4>
              <div className="diff-item"><span className="diff-dot dot-good" />"Your factors multiply to +6 but add to −5. What must the signs be?"</div>
              <div className="diff-item"><span className="diff-dot dot-good" />Highlights the exact error, not the full answer</div>
              <div className="diff-item"><span className="diff-dot dot-good" />Student thinks, corrects, internalises the concept</div>
              <div className="diff-item"><span className="diff-dot dot-good" />Next variation → solved independently</div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="features" style={{ background: "var(--bg2)" }}>
        <div className="section-inner">
          <div className="section-tag">Features</div>
          <h2 className="section-title">Everything a serious<br />aspirant needs.</h2>
          <div className="features-alt">
            <div className="feat-row">
              <div className="feat-visual">
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 48, marginBottom: 12 }}>🔬</div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: "var(--blue)" }}>Adaptive Learning Path</div>
                  <div style={{ fontSize: 14, color: "var(--muted)", marginTop: 8, maxWidth: 240 }}>Syllabus adjusts to your weak areas in real time</div>
                  <div style={{ marginTop: 20, display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                    <span style={{ background: "rgba(79,195,247,0.1)", color: "var(--blue)", padding: "4px 12px", borderRadius: 20, fontSize: 12 }}>Physics</span>
                    <span style={{ background: "rgba(245,166,35,0.1)", color: "var(--amber)", padding: "4px 12px", borderRadius: 20, fontSize: 12 }}>Chemistry</span>
                    <span style={{ background: "rgba(34,197,94,0.1)", color: "#22c55e", padding: "4px 12px", borderRadius: 20, fontSize: 12 }}>Mathematics</span>
                    <span style={{ background: "rgba(168,85,247,0.1)", color: "#a855f7", padding: "4px 12px", borderRadius: 20, fontSize: 12 }}>Biology</span>
                  </div>
                </div>
              </div>
              <div className="feat-content">
                <div className="feat-num">01</div>
                <h3>Adaptive Learning Path</h3>
                <p>KalamAI tracks every interaction to understand exactly where you're struggling. Your study plan reshapes itself daily — so you spend time on what matters most, not what you already know.</p>
                <span className="feat-pill">JEE · NEET · Boards · Foundation · Olympiads</span>
              </div>
            </div>

            <div className="feat-row reverse">
              <div className="feat-visual">
                <div className="feat-icon-grid">
                  <div className="feat-icon-item"><div className="fi">📸</div><span>Photo Scan</span></div>
                  <div className="feat-icon-item"><div className="fi">✍️</div><span>Handwriting</span></div>
                  <div className="feat-icon-item"><div className="fi">🎤</div><span>Voice Mode</span></div>
                  <div className="feat-icon-item"><div className="fi">⌨️</div><span>Type It In</span></div>
                </div>
              </div>
              <div className="feat-content">
                <div className="feat-num">02</div>
                <h3>Ask Any Way You Want</h3>
                <p>Photo of your notebook. Handwritten working. Voice question in Hindi or English. KalamAI understands it all. No barriers between your doubt and your breakthrough.</p>
                <span className="feat-pill">Multilingual Support</span>
              </div>
            </div>

            <div className="feat-row">
              <div className="feat-visual">
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 14, color: "var(--muted)", marginBottom: 16 }}>Error Detection</div>
                  <div style={{ background: "#1a2a3a", border: "1px solid #4FC3F7", borderRadius: 12, padding: 20, maxWidth: 280, textAlign: "left" }}>
                    <div style={{ fontSize: 13, color: "#81d4fa", marginBottom: 8 }}>🔍 KalamAI found an error in Step 2</div>
                    <div style={{ fontSize: 15, color: "#ccc", background: "rgba(79,195,247,0.1)", borderLeft: "3px solid var(--blue)", padding: "8px 12px", borderRadius: 4, fontFamily: "Georgia,serif", fontStyle: "italic" }}>F = ma² ← incorrect</div>
                    <div style={{ fontSize: 13, color: "#81d4fa", marginTop: 12 }}>"Check the formula for Newton's 2nd law — what are the units of force?"</div>
                  </div>
                </div>
              </div>
              <div className="feat-content">
                <div className="feat-num">03</div>
                <h3>Pinpoint Error Detection</h3>
                <p>KalamAI doesn't just say "wrong." It highlights the precise step where your reasoning broke down, and asks a targeted question to steer you back — just like a personal tutor sitting next to you.</p>
                <span className="feat-pill">Works across all subjects</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials-section">
        <div className="section-inner">
          <div className="section-tag" style={{ textAlign: "center" }}>Early Feedback</div>
          <h2 className="section-title" style={{ textAlign: "center" }}>What aspirants are saying.</h2>
          <div className="testi-grid">
            <div className="testi-card">
              <div className="testi-stars">★★★★★</div>
              <p className="testi-quote">"Finally an AI that doesn't just hand me the answer. I actually understood integration by parts after KalamAI asked me two questions."</p>
              <div className="testi-author">
                <div className="testi-avatar" style={{ background: "linear-gradient(135deg,var(--amber),#e08800)" }}>AR</div>
                <div><div className="testi-name">Aryan R.</div><div className="testi-sub">JEE Advanced aspirant · Pune</div></div>
              </div>
            </div>
            <div className="testi-card">
              <div className="testi-stars">★★★★★</div>
              <p className="testi-quote">"My coaching sir gives 40 students the same explanation. KalamAI gives me mine. The difference in how much I retain is night and day."</p>
              <div className="testi-author">
                <div className="testi-avatar" style={{ background: "linear-gradient(135deg,var(--blue),#0277bd)" }}>PS</div>
                <div><div className="testi-name">Priya S.</div><div className="testi-sub">NEET aspirant · Hyderabad</div></div>
              </div>
            </div>
            <div className="testi-card">
              <div className="testi-stars">★★★★★</div>
              <p className="testi-quote">"Mere bête ko Chemistry mein bohot problem thi. KalamAI ne ek hafte mein jo kiya, vo coaching ne 3 mahine mein nahi kiya."</p>
              <div className="testi-author">
                <div className="testi-avatar" style={{ background: "linear-gradient(135deg,#22c55e,#15803d)" }}>VM</div>
                <div><div className="testi-name">Vandana M.</div><div className="testi-sub">Parent · Nagpur</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* B2B */}
      <section className="b2b-section" id="institutes">
        <div className="section-inner">
          <div className="section-tag">For Coaching Institutes</div>
          <div className="b2b-inner">
            <div>
              <h2 className="section-title">Power your institute<br />with <span style={{ color: "var(--blue)" }}>AI-backed</span><br />Socratic tutoring.</h2>
              <p style={{ color: "var(--muted)", fontSize: 16, lineHeight: 1.7, marginBottom: 32 }}>Give every student in your batch a personalised AI tutor that reinforces what your faculty teaches — without replacing them.</p>
              <div className="b2b-features">
                <div className="b2b-feat"><span className="b2b-check">✦</span> White-label dashboard for your institute brand</div>
                <div className="b2b-feat"><span className="b2b-check">✦</span> Student progress analytics for your faculty</div>
                <div className="b2b-feat"><span className="b2b-check">✦</span> Custom question bank integration</div>
                <div className="b2b-feat"><span className="b2b-check">✦</span> Works across Telangana, AP, Maharashtra, MP, CG</div>
              </div>
              <a href="#waitlist" className="btn-primary" style={{ display: "inline-block", marginTop: 32 }} data-testid="b2b-partner-btn">Partner With Us</a>
            </div>
            <div className="b2b-visual">
              <div className="b2b-num">5+</div>
              <div className="b2b-label">States · Active Outreach</div>
              <div className="b2b-divider" />
              <div className="b2b-num">500+</div>
              <div className="b2b-label">Coaching Institutes in Network</div>
              <div className="b2b-divider" />
              <div className="b2b-num">₹0</div>
              <div className="b2b-label">Cost to partner during pilot</div>
            </div>
          </div>
        </div>
      </section>

      {/* FOUNDERS */}
      <section className="founders-section" id="founders">
        <div className="section-inner">
          <div className="section-tag">The Team</div>
          <h2 className="section-title">Built by educators,<br />not just engineers.</h2>
          <div className="founders-grid">
            <div className="founder-card" style={{ maxWidth: 600 }}>
              {!imgError ? (
                <img
                  src="/founder_photo.jpg"
                  alt="Shubham Jha — Founder, KalamAI"
                  className="founder-photo"
                  onError={() => setImgError(true)}
                  loading="lazy"
                  data-testid="founder-photo"
                />
              ) : (
                <div className="founder-initials" style={{ background: "linear-gradient(135deg,#1a1a3a,#09090f)", color: "var(--amber)", borderColor: "var(--amber)" }}>SJ</div>
              )}
              <div className="founder-info">
                <h3>Shubham Jha</h3>
                <div className="founder-role">Founder &amp; CEO · Gyaantra Technologies</div>
                <p className="founder-bio">B.Tech CS graduate and GATE CSE 2026 qualifier. Former senior JEE faculty with hands-on classroom experience. National-level quizmaster with 200+ competitions and 60+ podium finishes. Building the future of learning for India's crores of aspirants — across Boards, JEE, NEET, Foundation, and Olympiads.</p>
                <div className="founder-socials">
                  <a href="https://www.linkedin.com/in/shubham-jha-founder/" target="_blank" rel="noreferrer" className="social-link" title="LinkedIn" data-testid="linkedin-link"><LinkedInIcon /></a>
                  <a href="https://www.instagram.com/inquisitive_idealist/" target="_blank" rel="noreferrer" className="social-link" title="Instagram" data-testid="instagram-link"><InstaIcon /></a>
                  <a href="https://x.com/the_jhason" target="_blank" rel="noreferrer" className="social-link" title="X / Twitter" data-testid="x-link"><XIcon /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FUTURE BANNER */}
      <section style={{ padding: "80px 5% 40px" }}>
        <div className="section-inner">
          <div className="future-banner">
            <div className="section-tag" style={{ textAlign: "center" }}>Our Mission</div>
            <h2>The Future of <span style={{ background: "linear-gradient(90deg,var(--amber),var(--blue))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Learning</span> is Here.</h2>
            <p>KalamAI is building the infrastructure for a generation of Indian students who don't just crack exams — they understand the world they're entering.</p>
          </div>
        </div>
      </section>

      {/* WAITLIST */}
      <section className="waitlist-section" id="waitlist">
        <div className="waitlist-glow" />
        <div className="section-inner" style={{ position: "relative" }}>
          <div className="section-tag" style={{ textAlign: "center" }}>Early Access</div>
          <h2 className="section-title" style={{ textAlign: "center" }}>Join <span style={{ background: "linear-gradient(90deg,var(--amber),var(--amber2))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>15,000+</span> aspirants<br />on the waitlist.</h2>
          <p style={{ color: "var(--muted)", fontSize: 18, maxWidth: 480, margin: "0 auto 8px", lineHeight: 1.6, textAlign: "center" }}>Be among the first to get access when we launch. Free for early users.</p>

          {!submitted ? (
            <form className="waitlist-form" onSubmit={submit} data-testid="waitlist-form">
              <input className="waitlist-input" type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="waitlist-name-input" />
              <input className="waitlist-input" type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="waitlist-email-input" />
              <input className="waitlist-input" type="tel" placeholder="Phone number" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ width: 180 }} data-testid="waitlist-phone-input" />
              <button className="waitlist-btn" type="submit" disabled={loading} data-testid="waitlist-submit-btn">{loading ? "Submitting..." : "Get Early Access →"}</button>
            </form>
          ) : (
            <div className="waitlist-success" data-testid="waitlist-success">🎉 You're on the list! Watch your inbox — we'll reach out soon.</div>
          )}
          <p className="waitlist-note">No spam. We'll only reach out when you're up. Promise.</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="klm-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <span>KalamAI</span>
            <span className="sub">by Gyaantra Technologies</span>
            <p>Building the future of learning for India's 2 crore JEE &amp; NEET aspirants. Powered by the Socratic method.</p>
          </div>
          <div className="footer-col">
            <h4>Product</h4>
            <a href="#how-it-works">How It Works</a>
            <a href="#features">Features</a>
            <a href="#waitlist">Join Waitlist</a>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <a href="#founders">About Us</a>
            <a href="#institutes">For Institutes</a>
            <a href="mailto:hello@gyaantra.online">Contact</a>
          </div>
          <div className="footer-col">
            <h4>Connect</h4>
            <a href="https://www.linkedin.com/in/shubham-jha-founder/" target="_blank" rel="noreferrer">LinkedIn</a>
            <a href="https://www.instagram.com/inquisitive_idealist/" target="_blank" rel="noreferrer">Instagram</a>
            <a href="https://x.com/the_jhason" target="_blank" rel="noreferrer">X / Twitter</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Gyaantra Technologies. All rights reserved.</p>
          <span className="future-tag">The Future of Learning — KalamAI</span>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
